"use client";
import React from "react";
import Image from "next/image";
import { Button } from "@/components/hongkong-setup-v2/ui/button";
import { Card, CardContent } from "@/components/hongkong-setup-v2/ui/card";
import { WA_NUMBERS } from "@/lib/consultation-links";
import { openWhatsAppWithUtm } from "@/lib/whatsapp";


const processSteps = [
  {
    number: 1,
    duration: "3-5 days",
    title: "Hong Kong Company Formation",
    description:
      "We handle your complete Hong Kong Limited company setup with proper business registration, ensuring compliance with local regulations and positioning you for financial services approval.",
    position: "bottom",
  },
  {
    number: 2,
    duration: "2-3 days",
    title: "Business Address & Compliance Setup",
    description:
      "We secure a legitimate Hong Kong business address that satisfies banking and PSP requirements, plus handle all compliance documentation for smooth approvals.",
    position: "top",
  },
  {
    number: 3,
    duration: "2-5 days",
    title: "PayPal HK Verified Account",
    description:
      "We complete PayPal Hong Kong setup with proper verification and insider approval tactics, giving you access to PayPal's global payment network from Hong Kong.",
    position: "bottom",
  },
  {
    number: 4,
    duration: "3-7 days",
    title: "Airwallex Multi-Currency Account",
    description:
      "We open your Airwallex business account with proper documentation, enabling seamless multi-currency operations and global payment processing capabilities.",
    position: "top",
  },
  {
    number: 5,
    duration: "5-10 days",
    title: "Ocean Payment Merchant Setup",
    description:
      "We activate your Ocean Payment merchant account with insider knowledge of their approval process, ensuring smooth underwriting and rapid account activation.",
    position: "bottom",
  },
];

const benefits = [
  "Unlimited transaction volume",
  "Multi-currency operations",
  "Instant fund access",
  "100% Compliant & Secure",
];

export const FrameContainerSection = () => {
  return (
    <section className="flex flex-col w-full items-center gap-12 sm:gap-16 md:gap-20 lg:gap-[32px] py-8 sm:py-12 md:py-[70px]">
      <div className="flex flex-col items-center gap-6 sm:gap-8 md:gap-10 w-full max-w-[1343px] px-4 sm:px-6 md:px-8">
        <header className="flex flex-col items-start gap-4 sm:gap-5 md:gap-[19.31px] w-full">
          <div className="flex flex-col items-center w-full">
          <h2
  className="relative w-full text-center
  bg-[radial-gradient(closest-side,rgba(21,93,252,1)_0%,rgba(255,255,255,1)_100%),linear-gradient(to_left,#fafafa,#fafafa)]
  bg-clip-text text-transparent
  font-['SharpGroteskPeTrialBook-20',sans-serif]
  lg:text-[70px] text-[36px] leading-[120%] font-normal"
>
  We Take You From Zero to a Fully
  <br />
 <span className="text-white">Activated Hong Kong PSP</span>
</h2>
          </div>

          <div className="flex flex-col items-center w-full">
            <p className="flex items-center justify-center w-full max-w-[840px] font-inter font-[300] text-[#A1A1AA] text-sm sm:text-base md:text-lg lg:text-[18px] tracking-[-1px] text-center leading-5 sm:leading-6 px-2">
            A Hong Kong PSP setup is a compliance maze... strict rules, banking barriers, and hidden requirements that most entrepreneurs aren't prepared for.
            </p>
          </div>
        </header>

        {/* Mobile/Tablet Timeline - Vertical Layout */}
        <div className="flex lg:hidden flex-col w-full gap-6">
          {processSteps.map((step) => (
            <Card
              key={step.number}
              className="w-full bg-[#0f1218] rounded-2xl border-0"
            >
              <CardContent className="flex flex-col items-center gap-1 lg:gap-4 p-4 sm:p-6">
                {/* <div className="flex items-center gap-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full border-4 border-solid border-[#14224d] bg-[linear-gradient(180deg,rgba(51,92,255,1)_0%,rgba(111,166,255,1)_100%)] flex items-center justify-center flex-shrink-0">
                    <span className="font-inter font-bold text-white text-sm sm:text-base">
                      {step.number}
                    </span>
                  </div>
                  <div className="relative">
                    <Image                       className="w-16 h-8 sm:w-20 sm:h-9"
                      alt="Duration badge"
                      src="/hongkong-setup-v2/chatdown.svg"
                    width={800} height={600} />
                    <span className="absolute top-1 sm:top-1.5 left-2 sm:left-3 font-inter font-semibold text-white text-xs sm:text-sm whitespace-nowrap">
                      {step.duration}
                    </span>
                  </div>
                </div> */}
                <div className="flex flex-col sm:flex-row items-center sm:items-center gap-0 sm:gap-4">
                  {/* STEP NUMBER CIRCLE */}
                  <div
                    className="w-12 h-12 sm:w-14 sm:h-14 rounded-full border-4 border-solid border-[#14224d]
    bg-[linear-gradient(180deg,rgba(51,92,255,1)_0%,rgba(111,166,255,1)_100%)]
    flex items-center justify-center flex-shrink-0
  "
                  >
                    <span className="font-inter font-bold text-white text-sm sm:text-base">
                      {step.number}
                    </span>
                  </div>

                  {/* DURATION BADGE */}
                  <div className="relative order-2 sm:order-none">
                    <Image
                      className="w-16 h-8 sm:w-20 sm:h-9"
                      alt="Duration badge"
                      src="/hongkong-setup-v2/chatdown.svg"
                      width={800}
                      height={600}
                    />
                    <span
                      className="
      absolute
      top-1 sm:top-1.5
      left-2 sm:left-3
      font-inter
      font-semibold
      text-white
      text-xs sm:text-sm
      whitespace-nowrap
    "
                    >
                      {step.duration}
                    </span>
                  </div>
                </div>

                <h3 className="font-inter font-bold text-[#dfdfdf] text-base sm:text-lg text-center leading-6">
                  {step.title}
                </h3>

                <p className="font-inter font-normal text-zinc-400 text-sm sm:text-[15.5px] text-center leading-5">
                  {step.description}
                </p>
              </CardContent>
            </Card>
          ))}

          {/* Mission Accomplished Card for Mobile */}
          <Card className="w-full bg-[#0f1218] rounded-2xl border-0">
            <CardContent className="flex flex-col items-center gap-4 p-4 sm:p-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full border-4 border-solid border-[#14224d] bg-[linear-gradient(180deg,rgba(51,92,255,1)_0%,rgba(111,166,255,1)_100%)] flex items-center justify-center flex-shrink-0">
                  <span className="font-inter font-bold text-white text-sm sm:text-base">
                    6
                  </span>
                </div>
              </div>

              <Image
                className="w-16 h-16 sm:w-20 sm:h-20"
                alt="Mission accomplished shield"
                src="/hongkong-setup-v2/freepik--two-overlapping-luxury-security-shields-front-shie--566.png"
                width={800}
                height={600}
              />

              <h3 className="font-inter font-bold text-[#dfdfdf] text-base sm:text-lg text-center">
                Mission Accomplished!
              </h3>

              <p className="font-inter font-normal text-zinc-400 text-sm sm:text-[15.5px] text-center leading-5">
                Your Hong Kong PSP Empire is Active. Now You Have Access To:
              </p>

              <div className="flex flex-col items-start gap-2">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex gap-2 items-center">
                    <span className="font-inter font-normal text-green-400 text-base">
                      ✓
                    </span>
                    <span className="opacity-90 font-inter font-normal text-zinc-400 text-sm sm:text-[15px]">
                      {benefit}
                    </span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Desktop Timeline - Horizontal Layout */}
        <div className="hidden lg:block relative w-full max-w-[1347px] h-[636.57px]">
          <Image
            className="absolute top-[364px] left-1/2 -translate-x-1/2 w-[1142px] h-px object-cover"
            alt="Timeline connector"
            src="/hongkong-setup-v2/line.svg"
            width={800}
            height={600}
          />

          <div className="absolute top-0 right-[-50px] shadow-[0px_5px_15px_rgba(0,0,0,0.3),0px_0px_25px_rgba(51,92,255,0.48)] w-[250px] h-[298px] overflow-hidden">
        
            <Card className="w-full h-full bg-[#0f1218] rounded-[10px] border-0 relative overflow-hidden">
              <div className="absolute left-[-239px] bottom-[-550.461px] w-[297px] h-[828.977px] rotate-[-94.595deg] bg-[linear-gradient(180deg,rgba(255,255,255,0.60)_37.91%,rgba(51,92,255,0.48)_81.25%,rgba(51,92,255,0.12)_100%)] blur-[40px]"></div>
              <CardContent className="flex flex-col items-center gap-4 p-2">
                <Image
                  className="w-[70px] h-[70px]"
                  alt="Mission accomplished shield"
                  src="/hongkong-setup-v2/freepik--two-overlapping-luxury-security-shields-front-shie--566.png"
                  width={800}
                  height={600}
                />

                <h3 className="flex items-center justify-center w-[214px] font-inter font-bold text-[#dfdfdf] text-lg text-center tracking-[-0.72px] leading-6">
                  Mission Accomplished!
                </h3>

                <div className="flex flex-col items-center gap-[5px] w-full">
                  <p className="flex items-center justify-center w-full font-inter font-normal text-zinc-400 text-[15.5px] text-center tracking-[-0.62px] leading-5">
                    Your Hong Kong PSP Empire is Active. Now You Have Access To:
                  </p>

                  <div className="flex flex-col items-start gap-[5px]">
                    {benefits.map((benefit, index) => (
                      <div
                        key={index}
                        className="flex justify-center gap-[5px] items-start"
                      >
                        <span className="flex items-center justify-center font-inter font-normal text-green-400 text-base text-center tracking-[0] leading-6">
                          ✓
                        </span>
                        <span className="flex items-center justify-center opacity-90 font-inter font-normal text-zinc-400 text-[15px] text-center tracking-[0] leading-6 whitespace-nowrap">
                          {benefit}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* <Image                   className="absolute top-[190px] left-[-439px] w-[850px] h-[362px]"
                  alt="Background decoration"
                  src="/hongkong-setup-v2/rectangle-13.svg"
                width={800} height={600} /> */}

                {/* <Image                   className="absolute top-[-4148px] left-[-1156px] w-[297px] h-[829px]"
                  alt="Background decoration"
                  src="/hongkong-setup-v2/rectangle-10.svg"
                width={800} height={600} /> */}
              </CardContent>
            </Card>
          </div>

          <div className="absolute top-[335px] right-[40px] w-[60px] h-[60px] rounded-full border-[6px] border-solid border-[#14224d] bg-[linear-gradient(180deg,rgba(51,92,255,1)_0%,rgba(111,166,255,1)_100%)] flex items-center justify-center">
            <span className="font-inter font-bold text-white text-base tracking-[-0.64px] leading-6">
              6
            </span>
          </div>

          {processSteps.map((step, index) => {
            const desktopPositions = [
              { left: "0px", top: "295px" }, // Step 1
              { left: "229px", top: "131px" }, // Step 2
              { left: "443px", top: "295px" }, // Step 3
              { left: "674px", top: "131px" }, // Step 4
              { left: "924px", top: "295px" }, // Step 5
            ];

            return (
              <div
                key={step.number}
                className="absolute flex flex-col items-center gap-6"
                style={{
                  left: desktopPositions[index].left,
                  top: desktopPositions[index].top,
                  width: step.number === 5 ? "234px" : "214px",
                }}
              >
                {step.position === "bottom" && (
                  <>
                    <div className="flex flex-col items-start gap-2.5">
                      <div className="relative w-20 h-[35.26px]">
                        <Image
                          className="absolute top-0 left-0 w-[78px] h-[35px]"
                          alt="Duration badge"
                          src="/hongkong-setup-v2/chatdown.svg"
                          width={800}
                          height={600}
                        />
                        <span className="absolute top-[5px] left-[11px] h-5 flex items-center justify-center font-inter font-semibold text-white text-[15px] text-center tracking-[-0.60px] leading-5 whitespace-nowrap">
                          {step.duration}
                        </span>
                      </div>

                      <div className="w-[60px] h-[60px] rounded-full border-[6px] border-solid border-[#14224d] bg-[linear-gradient(180deg,rgba(51,92,255,1)_0%,rgba(111,166,255,1)_100%)] flex items-center justify-center">
                        <span className="font-inter font-bold text-white text-base tracking-[-0.64px] leading-6">
                          {step.number}
                        </span>
                      </div>
                    </div>

                    <div className="flex flex-col items-center w-full gap-4">
                      <h3 className="flex items-center justify-center w-[178px] [font-family:'SharpGroteskPeTrialSmBold-15',sans-serif] font-normal text-[#dfdfdf] text-lg text-center tracking-[-0.72px] leading-6">
                        {step.title}
                      </h3>

                      <p className="flex items-center justify-center w-full font-inter font-normal text-zinc-400 text-[15.5px] text-center tracking-[-0.62px] leading-5">
                        {step.description}
                      </p>
                    </div>
                  </>
                )}

                {step.position === "top" && (
                  <>
                    <div className="flex flex-col items-center w-full gap-4">
                      <h3 className="flex items-center justify-center w-[178px] [font-family:'SharpGroteskPeTrialSmBold-15',sans-serif] font-normal text-[#dfdfdf] text-lg text-center tracking-[-0.72px] leading-6">
                        {step.title}
                      </h3>

                      <p className="flex items-center justify-center w-full font-inter font-normal text-zinc-400 text-[15.5px] text-center tracking-[-0.62px] leading-5">
                        {step.description}
                      </p>
                    </div>

                    <div className="flex flex-col items-center gap-[13px] ">
                      <div className="w-[60px] h-[60px] rounded-full border-[6px] border-solid border-[#14224d] bg-[linear-gradient(180deg,rgba(51,92,255,1)_0%,rgba(111,166,255,1)_100%)] flex items-center justify-center">
                        <span className="font-inter font-bold text-white text-base tracking-[-0.64px] leading-6">
                          {step.number}
                        </span>
                      </div>

                      <div className="relative w-20 h-[35.26px]">
                        <Image
                          className="absolute top-0 left-0 w-[78px] h-[35px]"
                          alt="Duration badge"
                          src="/hongkong-setup-v2/union-1.svg"
                          width={800}
                          height={600}
                        />
                        <span className="absolute top-2.5 left-[11px] h-5 flex items-center justify-center font-inter font-bold text-white text-[15px] text-center tracking-[-0.60px] leading-5 whitespace-nowrap">
                          {step.duration}
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex flex-col items-center gap-3 sm:gap-[24px] w-full max-w-[1343px] px-4 sm:px-6 md:px-8">
        <div className="flex items-center justify-center w-full gap-3">
          <button
            type="button"
            onClick={() => openWhatsAppWithUtm(WA_NUMBERS, "hk-setup")}
            className="
             cursor-pointer h-9 px-4 py-2
    relative
    w-full sm:w-auto
    inline-flex items-center justify-center gap-2
     sm:py-6
    rounded-xl
    bg-[#335cff]
    text-white
    font-normal
    overflow-hidden

   lg:px-[58px]

    transition-all duration-300 ease-out
    hover:scale-[1.03]
    hover:-translate-y-1
    hover:shadow-[0_12px_30px_rgba(51,92,255,0.45)]
    hover:bg-gradient-to-r hover:from-[#476cff] hover:to-[#004eff]
    active:scale-[0.98]
  "
          >
            <div className="hidden sm:block absolute top-10 left-1 w-[326px] h-20 rounded-[163px/40px] bg-[#d9d9d9] blur-[27px]" />
            <span className="relative font-inter font-normal  text-white text-sm sm:text-base md:text-lg tracking-[-0.36px] leading-6 sm:leading-7 text-center">
              Start Your Hong Kong PSP Setup
            </span>
          </button>
        </div>

      
          <div className="inline-flex h-auto items-center gap-2 px-3 sm:px-4 rounded-lg sm:rounded-xl backdrop-blur-[2px] backdrop-brightness-[100%] [-webkit-backdrop-filter:blur(2px)_brightness(100%)]">
            <span className=" opacity-90 font-inter font-[300] text-[#FAFAFA]">
              Complete Hong Kong PSP setup - €4000 investment
            </span>
          </div>
        
      </div>
    </section>
  );
};
